import {
  opmStorage,
  Keys,
  migrateGuestCartToElement,
  DEFAULT_TTL_SECONDS,
  GUEST_ELEMENT_SCOPE,
  tableScopeOf,
} from "./opmStorage";

const COOKIE_TTL_SECONDS = DEFAULT_TTL_SECONDS;

export const setCookie = (name, value, ttlSeconds = COOKIE_TTL_SECONDS) => {
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${ttlSeconds}; path=/; SameSite=Strict`;
};

export const getCookie = (name) => {
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : null;
};

export const removeCookie = (name) => {
  document.cookie = `${name}=; max-age=0; path=/; SameSite=Strict`;
};

/**
 * Persist JWT under namespaced storage (not HttpOnly — prefer server-set cookie when available).
 * Sets non-secret restaurant/element cookies for bootstrap + migrates guest cart to element scope.
 */
export const saveAuthCookies = (token, claims) => {
  const r = claims?.restaurant_id;
  const e = tableScopeOf(claims);
  if (r && e) {
    migrateGuestCartToElement(r, e);
    opmStorage.setWithTtl(Keys.token(r, e), token, COOKIE_TTL_SECONDS);
    setCookie("opm_restaurant_id", String(r));
    setCookie("opm_element_id", String(e));
  }
};

/** Saved OPM display name for current cookie scope (same key as NameModal / guest checkout). */
export const readScopedGuestDisplayName = () => {
  const r = getCookie("opm_restaurant_id");
  if (!r) return "";
  const e = getCookie("opm_element_id") || GUEST_ELEMENT_SCOPE;
  return opmStorage.getWithTtl(Keys.guestName(r, e)) || "";
};
